import { Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { ControllingPersonType } from "../../../../../../../../Wrap/Constants/Enums/Customer/ControllingPersonType";
import { EligibilityStatus } from "../../../../../../../../Wrap/Constants/Enums/Domain/EligibilityStatus";
import { InvestorType } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";

export const EligibilityStatusOptions: Dictionary[] = [
    { key: EligibilityStatus.NotApplicable + "", value: "Not Applicable" },
    { key: EligibilityStatus.UnableToBeCured + "", value: "Reportable" },
    { key: EligibilityStatus.Cured + "", value: "Not Reportable" },
    { key: EligibilityStatus.NeedsReview + "", value: "Needs Review" },
];

export const investorTypeMap = {
    [InvestorType.Consolidated]: "Consolidated",
    [InvestorType.FundManager]: "Fund manager",
    [InvestorType.Trust]: "Trust",
    [InvestorType.Individual]: "Individual",
    [InvestorType.Individ]: "Individ",
    [InvestorType.Joint]: "Joint",
    [InvestorType.JointIndividual]: "Joint individual",
};

export const EligibilityStatusMap = {
    [EligibilityStatus.NotApplicable]: "Not Applicable",
    [EligibilityStatus.UnableToBeCured]: "Reportable",
    [EligibilityStatus.Cured]: "Not Reportable",
    [EligibilityStatus.NeedsReview]: "Needs Review",
};

export const InterestedPartySteppers = {
    clientDetails: "Client details",
};
export const ControllingPersonTypeArray = [
    ControllingPersonType.NotSpecified,
    ControllingPersonType.ControlLegalPersonByOwnership,
    ControllingPersonType.ControlLegalPersonByOtherMeans,
    ControllingPersonType.ControlLegalPersonBySeniorManger,
    ControllingPersonType.ControlTrustBySettlor,
    ControllingPersonType.ControlTrustByTrustee,
    ControllingPersonType.ControlTrustByProtector,
    ControllingPersonType.ControlTrustByBeneficiary,
    ControllingPersonType.ControlTrustByOther,
    ControllingPersonType.ControlNonTrustBySettlor,
    ControllingPersonType.ControlNonTrustByTrustee,
    ControllingPersonType.ControlNonTrustByProtector,
    ControllingPersonType.ControlNonTrustByBeneficiary,
    ControllingPersonType.ControlNonTrustByOther,
];
export const ControllingPersonTypeMap = {
    [ControllingPersonType.NotSpecified]: "Not Specified",
    [ControllingPersonType.ControlLegalPersonByOwnership]:
        "Controlling Person of a legal person - control by ownership",
    [ControllingPersonType.ControlLegalPersonByOtherMeans]:
        "Controlling Person of a legal person - control by other means",
    [ControllingPersonType.ControlLegalPersonBySeniorManger]:
        "Controlling Person of a legal person - control by senior managing official",
    [ControllingPersonType.ControlTrustBySettlor]: "Controlling Person of a trust - settlor",
    [ControllingPersonType.ControlTrustByTrustee]: "Controlling Person of a trust - trustee",
    [ControllingPersonType.ControlTrustByProtector]: "Controlling Person of a trust - protector",
    [ControllingPersonType.ControlTrustByBeneficiary]: "Controlling Person of a trust - beneficiary",
    [ControllingPersonType.ControlTrustByOther]: "Controlling Person of a trust - other",
    [ControllingPersonType.ControlNonTrustBySettlor]:
        "Controlling Person of a legal arrangement(non-trust) - settlor-equivalent",
    [ControllingPersonType.ControlNonTrustByTrustee]:
        "Controlling Person of a legal arrangement(non-trust) - trustee-equivalent",
    [ControllingPersonType.ControlNonTrustByProtector]:
        "Controlling Person of a legal arrangement(non-trust) - protector-equivalent",
    [ControllingPersonType.ControlNonTrustByBeneficiary]:
        "Controlling Person of a legal arrangement(non-trust) - beneficiary-equivalent",
    [ControllingPersonType.ControlNonTrustByOther]:
        "Controlling Person of a legal arrangement(non-trust) - other-equivalent",
};
export const TrustMemberDeathValidationMsg = {
    hasOutstandingRequests: ". This Trustee already has an outstanding request for removal."
}